<template>
  <div class="contentBox min-w-1400">
    <div class="flexBox min-w-1400 fade-in-section">
      <div class="imgBox max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="flexGroup max-w-1400">
        <img :src="importedImg2a" alt="" class="imgItem left-fade-in-section" />
        <img :src="importedImg2b" alt="" class="imgItem up-fade-in-section" />
      </div>
    </div>
    <div class="flexBox min-w-1400 fade-in-section">
      <div class="imgBox max-w-1400">
        <img :src="importedImg3" alt="" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="flexGroup max-w-1400">
        <img :src="importedImg4a" alt="" class="imgItem up-fade-in-section" />
        <img :src="importedImg4b" alt="" class="imgItem right-fade-in-section" />
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/cre.inversionesmartinsas/components/img/index1.png";
import importedImg2a from "@/page/cre.inversionesmartinsas/components/img/index2a.png";
import importedImg2b from "@/page/cre.inversionesmartinsas/components/img/index2b.png";
import importedImg3 from "@/page/cre.inversionesmartinsas/components/img/index3.png";
import importedImg4a from "@/page/cre.inversionesmartinsas/components/img/index4a.png";
import importedImg4b from "@/page/cre.inversionesmartinsas/components/img/index4b.png";

export default {
  data() {
    return {
      importedImg1,
      importedImg2a,
      importedImg2b,
      importedImg3,
      importedImg4a,
      importedImg4b,
    };
  },
  mounted() {
    this.InitPage();
  },
  methods: {
    InitPage(){
      window.scrollTo({ top: 0 });
      const fadeInSections = document.querySelectorAll('.fade-in-section, .left-fade-in-section ,.right-fade-in-section, .up-fade-in-section')
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
      });
    }, {
        threshold: 0.1
    });
      fadeInSections.forEach(section => {
          observer.observe(section);
      });
    }
  },
};
</script>

<style scoped>
.contentBox {
  display: flex;
  flex-direction: column;
  background: #FCFCFC;
}
img {
  display: block;
}
.flexBox{
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.imgBox,.flexGroup{
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
  min-height: 400px;
}

.flexGroup {
  display: flex;
  justify-content: space-between;
}

.imgItem {
  width: 100%;
  margin: 0;
}

.flexGroup .imgItem{
  width: 45%;
}

.flexBox:nth-child(2) .flexGroup,
.flexBox:nth-child(4) .flexGroup {
  padding: 80px 180px;
}

</style>
